export default {
      id: "square-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#square",
      toString: function () {
        return this.url;
      }
    }